import { render, staticRenderFns } from "./BHeader.vue?vue&type=template&id=326bb0e6&"
import script from "./BHeader.vue?vue&type=script&lang=js&"
export * from "./BHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports